import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { API, setError } from '.'


export const fetchProducts = createAsyncThunk(
   'products/fetchProducts',
   async (itemsArr, thunkAPI) => {
      try {
         const response = await API.get(`/product`, {params:{items: itemsArr.join('_')}})
         return response.data
      } catch (err) {
         thunkAPI.dispatch(setError({ action: 'fetchProducts', code: err.response.status, message: err.message }))
         return thunkAPI.rejectWithValue()
      }
   },
   {
      condition: (itemsArr, { getState }) => {
         const entities = getState().products.entities
         const itemsIsLoaded = itemsArr.every(productUrl => productUrl in entities)
         if (itemsIsLoaded) return false
      }
   }
)

const initialState = {
   entities: {},
   loading: {}
}

const productsSlice = createSlice({
   name: 'products',
   initialState,
   extraReducers: builder => {
      builder.addCase(fetchProducts.pending, (state, action) => {
         const itemsArr = action.meta.arg
         itemsArr.forEach(productUrl => {
            state.loading[productUrl] = true
         })
      })
      builder.addCase(fetchProducts.fulfilled, (state, action) => {
         action.payload.forEach(item => {
            const { productUrl } = item
            state.entities[productUrl] = item
            state.loading[productUrl] = false
         })
      })
      builder.addCase(fetchProducts.rejected, (state, action) => {
         const itemsArr = action.meta.arg
         itemsArr.forEach(productUrl => {
            state.loading[productUrl] = false
         })
      })
   }
})

export const products = productsSlice.reducer
